/**
 * @param categoryPurchaseTypeId: From config 'CATEGORY_PURCHASE_TYPE_ID'
 * @param categories: From app server program data
 * @param nbaTvCategorySeoNames From config 'NBA_TV_CATEGORY_SEO_NAMES'
 * @param LPCategorySeoNames From config 'LP_CATEGORY_SEO_NAMES'
 * @param LPPCategorySeoNames From config 'LPP_CATEGORY_SEO_NAMES'
 * @returns {number|string}
 */
const getCategoryPurchase = (
		categoryPurchaseTypeId,
		categories,
		nbaTvCategorySeoNames,
		LPCategorySeoNames,
		LPPCategorySeoNames,
	) => {
	let purchaseTypeId = categoryPurchaseTypeId;
	let nbaTvMatched = false;
	let LPMatched = false;
	let LPPMatched = false;
	if (Array.isArray(categories)) {
		for (let i = 0; i < categories.length; i += 1) {
			const curSeoName = categories[i].seoName.toLowerCase();
			if (nbaTvCategorySeoNames
					&& nbaTvCategorySeoNames.indexOf(curSeoName.toLowerCase()) > -1) {
				nbaTvMatched = true;
			} else if (LPCategorySeoNames
					&& LPCategorySeoNames.indexOf(curSeoName.toLowerCase()) > -1) {
				LPMatched = true;
			} else if (LPPCategorySeoNames
					&& LPPCategorySeoNames.indexOf(curSeoName.toLowerCase()) > -1) {
				LPPMatched = true;
			}
			if (nbaTvMatched && LPMatched && LPPMatched) {
				break;
			}
		}
	}
	// There are 4 Purchase: FREE(undefined), VAULT (1), PREMIUM (3), SUBSCRIBER (4))
	if (LPPMatched) {
		purchaseTypeId = 3;
	} else if (LPMatched) {
		purchaseTypeId = 4;
	} else if (nbaTvMatched) {
		purchaseTypeId = 'nbatv';
	}
	return purchaseTypeId;
};

export {getCategoryPurchase};
